import styled, { css } from "styled-components";

const Chip = styled.button<{
  isSelected?: boolean;
}>`
  padding: 1rem 1.8rem;
  border-radius: 10rem;
  border: 1px solid ${({ theme }) => theme.color.stroke.light};
  color: ${({ theme }) => theme.color.text.default};
  ${({ theme }) => theme.typography.body3.regular};

  ${({ isSelected = false }) =>
    isSelected
      ? css`
          border: 1px solid ${({ theme }) => theme.color.primary};
          background: ${({ theme }) => theme.color.brick[100]};
          color: ${({ theme }) => theme.color.text.highEmphasis};
        `
      : css`
          &:hover {
            border: 1px solid ${({ theme }) => theme.color.stroke.primary};
            color: ${({ theme }) => theme.color.text.highEmphasis};
          }
        `}
`;

export default Chip;
